import { ELEMENT_H1, ELEMENT_PARAGRAPH, withPlaceholders } from '@udecode/plate'

export const withStyledPlaceHolders = (components: any) =>
  withPlaceholders(components, [
    {
      key: ELEMENT_PARAGRAPH,
      placeholder: 'Bắt đầu soạn văn bản',
      hideOnBlur: true,
    },
    {
      key: ELEMENT_H1,
      placeholder: '',
      hideOnBlur: false,
    },
  ])
